// AUTO GENERATED FILE - Changes WILL be lost.
// en-GB - used as 'en' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Betslip",
  "product.last60-row-single": "NBA Last 60 Single Match",
  "product.sb-english-single": "English Soccerbet Single Match",
  "product.sb-italian-single": "Italian Soccerbet Single Match",
  "product.sb-greek-single": "Greek Soccerbet Single Match",
  "product.sb-english-league": "English Soccerbet League",
  "product.sb-italian-league": "Italian Soccerbet League",
  "product.sb-greek-league": "Greek Soccerbet League",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Place bet",
  "betslip.clear": "Clear all",
  "betslip.clearResult": "Clear",
  "betslip.noSelections": "Add selections to start betting",
  "betslip.notLoggedIn": "Login to start betting",
  "betslip.refresh": "Refresh",
  "betslip.totalStake": "Total stake",
  "betslip.noHistoryData": "No bet information available",
  "betslip.openBets": "Open Bets",
  "betslip.betHistory": "Bet History",
  "betslip.betHistoryWon": "Won",
  "betslip.betHistoryLost": "Lost",
  "loading.loading": "Loading",
  "loading.account": "Loading account",
  "loading.league": "Loading league",
  "loading.gameweeks": "Loading game weeks",
  "loading.markets": "Loading markets",
  "loading.bethistory": "Loading bet history",
  "login.loginRequired": "Login Required",
  "login.loginToBet": "Please login to start betting",
  "navigation.back": "Back",
  "navigation.close": "Close",
  "video.liveStreamAvailable": "Live streaming available",
  "video.logInToWatch": "Please log in to watch",
  "error.error": "Error",
  "error.404": "Page not found",
  "error.gameLaunchFailed": "Unable to launch game",
  "error.unknownErrorCode": "Unknown error: {code}",
  "error.minUnitStakeLimitExceeded": "Minimum stake is {limit}",
  "error.maxUnitStakeLimitExceeded": "Maximum stake is {limit}",
  "error.minTotalStakeLimitExceeded": "Minimum total stake is {limit}",
  "error.maxTotalStakeLimitExceeded": "Maximum total stake is {limit}",
  "error.stakeInvalidMultiple": "Stake must be a multiple of {multiple}",
  "error.notPlaced": "Not Placed",
  "error.wagerDisallowed": "Wager disallowed",
  "error.errorEventIsOff": "Event has started",
  "wagerType.Singles": "Singles",
  "wagerType.Doubles": "Doubles",
  "wagerType.Trebles": "Trebles",
  "wagerType.Accumulator": "Accumulator",
  "wagerType.Perm 4-Folds": "Perm 4-Folds",
  "wagerType.Perm 5-Folds": "Perm 5-Folds",
  "wagerType.Perm 6-Folds": "Perm 6-Folds",
  "wagerType.Perm 7-Folds": "Perm 7-Folds",
  "wagerType.Perm 8-Folds": "Perm 8-Folds",
  "wagerType.Perm 9-Folds": "Perm 9-Folds",
  "error.excess_bets": "Maximum of {limit} simultaneous wagers on betslip; please remove a wager",
  "product.sb-turkish-league": "Turkish Soccerbet League",
  "error.minBetslipLimitExceeded": "Minimum total betslip stake is {limit}",
  "error.maxBetslipLimitExceeded": "Maximum total betslip stake is {limit}",
  "error.exceededMaxPayout": "Maximum potential payout is {limit}; please reduce your stake.",
  "betslip.potentialReturns": "Potential Returns",
  "betslip.taxDisclaimer": "All your net winnings are taxed upon bet settlement. The tax amount will be calculated depending on the potential winnings of the bet.",
  "error.maintenanceEnabled": "The server is currently undergoing maintenance",
  "error.internalError": "Internal Error",
  "error.invalidSession": "The session is invalid",
  "error.accountDisabled": "Account is disabled",
  "error.invalidPlayerID": "Invalid player ID",
  "error.insufficientBalance": "Insufficient balance",
  "error.configError": "Configuration error",
  "error.betPlaceFailed": "Failed to place bet",
  "error.invalidProductID": "Invalid product ID",
  "error.playerReachedGamingLimits": "Player reached responsible gaming limits",
  "error.gameCycleDoesNotExist": "The game cycle does not exist",
  "error.betAmountLimitExceeded": "Exceeded potential win limit for unverified players",
  "betslip.netStake": "Net Stake",
  "betslip.tax": "Tax",
  "error.badReturns": "Potential returns are lower than gross stake",
  "betslip.taxDisclaimerPoland": "Winnings will be reduced by 10% for amounts over PLN 2,280.",
  "error.incompatibleVersion": "Unsupported application version. Please upgrade.",
  "product.iihf-row-single": "IIHF World Championship",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Return To Player",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "The average RTP for this game is {limit}",
  "error.betslipContainsInvalidOptions": "Betslip contains invalid options in red",
  "product.sb-scottish-single": "Scottish Soccerbet Single Match",
  "product.sb-spanish-single": "Spanish Soccerbet Single Match",
  "product.sb-spanish-league": "Spanish Soccerbet League",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "No more bets",
  "playtime": "Play Time",
  "gameId": "Game ID",
  "noGames": "There are no games available. Check back soon.",
  "Home": "Home",
  "Away": "Away",
  "Visitor": "Visitor",
  "rules": "Rules",
  "soccerbet.gameWeek": "GAMEWEEK",
  "soccerbet.noGameWeeks": "There are no game weeks available. Check back soon.",
  "soccerbet.league": "League Standings",
  "soccerbet.table.name": "Name",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "abbr.event.Both Teams To Score": "BTTS",
  "event.Both Teams To Score": "Both Teams To Score",
  "event.Over / Under": "Over/Under",
  "event.Double Chance": "Double Chance",
  "event.Match Result": "Match Result",
  "event.Exact Goals": "Exact Goals",
  "event.Correct Score": "Correct Score",
  "event.Match Result Both Score": "Match Result and Both Teams to Score",
  "event.Result Und/Over 1.5 Total Goals": "Match Result and Over/Under 1.5 Total Goals",
  "event.Result Und/Over 2.5 Total Goals": "Match Result and Over/Under 2.5 Total Goals",
  "event.Under Over 1.5 Total Goals": "Over/Under 1.5 Total Goals",
  "event.Under Over 2.5 Total Goals": "Over/Under 2.5 Total Goals",
  "event.Under Over 3.5 Total Goals": "Over/Under 3.5 Total Goals",
  "event.Under Over 4.5 Total Goals": "Over/Under 4.5 Total Goals",
  "event.Total Goals 1 To 2": "Total Goals 1 To 2",
  "event.Total Goals 1 To 3": "Total Goals 1 To 3",
  "event.Total Goals 1 To 4": "Total Goals 1 To 4",
  "event.Total Goals 2 To 3": "Total Goals 2 To 3",
  "event.Total Goals 2 To 4": "Total Goals 2 To 4",
  "event.Under Over 1.5 Home Goals": "Over/Under 1.5 Home Team Goals",
  "event.Under Over 1.5 Away Goals": "Over/Under 1.5 Away Team Goals",
  "event.Home Team Exact Goals": "Home Team Exact Goals",
  "event.Away Team Exact Goals": "Away Team Exact Goals",
  "selection.Yes": "Yes",
  "selection.No": "No",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Yes",
  "selection.1+No": "1+No",
  "selection.X+Yes": "X+Yes",
  "selection.X+No": "X+No",
  "selection.2+Yes": "2+Yes",
  "selection.2+No": "2+No",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "OVER",
  "selection.Under": "UNDER",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NOT",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Athletic Bilbao",
  "sb-spanish.team.ATM": "Atletico Madrid",
  "sb-spanish.team.FCB": "Barcelona",
  "sb-spanish.team.CAD": "Cadiz",
  "sb-spanish.team.CLV": "Celta Vigo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Granada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Mallorca",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madrid",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sevilla",
  "sb-spanish.team.VAL": "Valencia",
  "sb-spanish.team.VIL": "Villarreal",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "Celtic",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "Hearts",
  "sb-scottish.team.HIB": "Hiberian",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangers",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE",
  "iihf-row.team.CAN": "Canada",
  "iihf-row.team.FIN": "Finland",
  "iihf-row.team.RUS": "Russia",
  "iihf-row.team.USA": "United States",
  "iihf-row.team.CZE": "Czechia",
  "iihf-row.team.SWE": "Sweden",
  "iihf-row.team.SVK": "Slovakia",
  "iihf-row.team.NOR": "Norway",
  "iihf-row.team.DEN": "Denmark",
  "abbr.iihf-row.team.CAN": "CAN",
  "abbr.iihf-row.team.FIN": "FIN",
  "abbr.iihf-row.team.RUS": "RUS",
  "abbr.iihf-row.team.USA": "USA",
  "abbr.iihf-row.team.CZE": "CZE",
  "abbr.iihf-row.team.SWE": "SWE",
  "abbr.iihf-row.team.SVK": "SVK",
  "abbr.iihf-row.team.NOR": "NOR",
  "abbr.iihf-row.team.DEN": "DEN",
  "event.Icematchresnt": "Match Result (1X2) (Regulation Time)",
  "event.Icematchresot": "Match Result (1,2) (Including Overtime)",
  "event.Icebothteamstoscore": "Both Teams to Score (Regulation Time)",
  "event.Icecorrectscoreot": "Correct Score (Including Overtime)",
  "event.Iceexactgoalsot": "Exact Goals (Including Overtime)",
  "event.Icegamelines2nt": "Game Lines 2-way (Regulation Time)",
  "event.Icegamelines3nt": "Game Lines 3-way (Regulation Time)",
  "event.Iceou2p5totalgoalsot": "Over 2.5 Total Goals (Including Overtime)",
  "event.Iceou3p5totalgoalsot": "Over 3.5 Total Goals (Including Overtime)",
  "event.Iceou4p5totalgoalsot": "Over 4.5 Total Goals (Including Overtime)",
  "event.Iceteamaexactgoalsot": "Home Team Exact Goals (Including Overtime)",
  "event.Iceteambexactgoalsot": "Away Team Exact Goals (Including Overtime)",
  "event.Icematchresou3p5totalgoalsnt": "Match Result and Over/Under 3.5 Goals (Regulation Time)",
  "event.Icematchresou3p5totalgoalsot": "Match Result and Over/Under 3.5 Goals (Including Overtime)",
  "event.Icehighestscoreperiodnt": "Highest Scoring Period Lines (Regulation Time)",
  "event.Iceou25goalsteamateambot": "Over/Under 2.5 Home or Away Team Goals (Including Overtime)",
  "event.Icefirstteamtoscore": "Which Team will score first? (Including Overtime)",
  "event.Iceteamtowinmostperiods": "Team to Win Most Periods (Regulation Time)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3.5",
  "selection.A -3.0": "{home} -3.0",
  "selection.A -2.5": "{home} -2.5",
  "selection.A -2.0": "{home} -2.0",
  "selection.A -1.5": "{home} -1.5",
  "selection.A -1.0": "{home} -1.0",
  "selection.A +1.0": "{home} +1.0",
  "selection.A +1.5": "{home} +1.5",
  "selection.A +2.0": "{home} +2.0",
  "selection.A +2.5": "{home} +2.5",
  "selection.A +3.0": "{home} +3.0",
  "selection.A +3.5": "{home} +3.5",
  "selection.B -3.5": "{away} -3.5",
  "selection.B -3.0": "{away} -3.0",
  "selection.B -2.5": "{away} -2.5",
  "selection.B -2.0": "{away} -2.0",
  "selection.B -1.5": "{away} -1.5",
  "selection.B -1.0": "{away} -1.0",
  "selection.B +1.0": "{away} +1.0",
  "selection.B +1.5": "{away} +1.5",
  "selection.B +2.0": "{away} +2.0",
  "selection.B +2.5": "{away} +2.5",
  "selection.B +3.0": "{away} +3.0",
  "selection.B +3.5": "{away} +3.5",
  "selection.X -3.0": "X -3.0",
  "selection.X -2.0": "X -2.0",
  "selection.X -1.0": "X -1.0",
  "selection.X +1.0": "X +1.0",
  "selection.X +2.0": "X +2.0",
  "selection.X +3.0": "X +3.0",
  "selection.A & Over": "{home} & Over",
  "selection.A & Under": "{home} & Under",
  "selection.X & Over": "X & Over",
  "selection.X & Under": "X & Under",
  "selection.B & Over": "{away} & Over",
  "selection.B & Under": "{away} & Under",
  "selection.A Over": "{home} Over",
  "selection.A Under": "{home} Under",
  "selection.B Over": "{away} Over",
  "selection.B Under": "{away} Under"
}
